import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Careers() {
  useEffect(() => {
    document.title = 'Careers | Nalexus Technologies';
  }, []);

  return (
    <main id="main-content" className="sync-main sync-subpage">
      <section className="sync-page-hero sync-section">
        <div className="sync-shell sync-page-hero-grid">
          <div>
            <p className="sync-eyebrow">Careers at Nalexus</p>
            <h1>Do useful work. Build dependable systems.</h1>
          </div>
          <div>
            <p className="sync-lead">We publish roles only after the position, requirements, and application channel have been verified.</p>
            <p className="sync-availability-note">There are no verified openings listed on this page right now.</p>
            <Link className="sync-text-link" to="/contact?intent=other">Contact Nalexus <span aria-hidden="true">→</span></Link>
          </div>
        </div>
      </section>
    </main>
  );
}
